import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import assistantNameStore from 'shared/store/assistantNameStore';
import chatStore from 'shared/store/chatStore';
import colorsStore from 'shared/store/colorsStore';
import useAppStatus from 'shared/store/appStatusStore';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'shared/components/ui/select';

export const AssistantNameSelector: React.FC = () => {
  const navigate = useNavigate();
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  const { availableAssistants, selectedAssistant, setSelectedAssistant } = assistantNameStore();
  const { resetChatState } = chatStore();
  const setAppStatus = useAppStatus((state) => state.setAppStatus);

  const handleAssistantChange = useCallback(
    (newAssistant: string) => {
      if (newAssistant !== selectedAssistant) {
        setSelectedAssistant(newAssistant);
        resetChatState();
        setAppStatus('idle');
        navigate('/assistant');
      }
    },
    [selectedAssistant, setSelectedAssistant, resetChatState, setAppStatus, navigate]
  );

  if (availableAssistants.length <= 1) {
    return null;
  }

  return (
    <Select value={selectedAssistant} onValueChange={handleAssistantChange}>
      <SelectTrigger 
        className="h-10 w-[220px] shadow-sm hover:shadow-md transition-shadow"
        style={{
          backgroundColor: colorsConfig.white,
          color: colorsConfig.finecoBlack,
          border: `1.5px solid ${colorsConfig.finecoBluePrimary}`,
          borderRadius: '8px',
        }}
      >
        <SelectValue placeholder="Select assistant" />
      </SelectTrigger>
      <SelectContent
        style={{
          backgroundColor: colorsConfig.white,
          borderColor: colorsConfig.grayLight,
        }}
      >
        {availableAssistants.map((assistant) => (
          <SelectItem 
            key={assistant} 
            value={assistant}
            className="hover:bg-opacity-10"
            style={{
              color: colorsConfig.finecoBlack,
            }}
          >
            {assistant}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

